"use client";

import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";

interface PageNameContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
}

const PageNameContext = createContext<PageNameContextType | undefined>(
  undefined,
);

interface PageNameProviderProps {
  children: ReactNode;
}

export const PageNameProvider = ({ children }: PageNameProviderProps) => {
  const [pageTitle, setPageTitle] = useState<string>("Copilot Cloud");

  return (
    <PageNameContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageNameContext.Provider>
  );
};

export const usePageName = () => {
  const context = useContext(PageNameContext);
  if (context === undefined) {
    throw new Error("usePageName must be used within a PageNameProvider");
  }
  return context;
};

export const useSetPageTitle = (title: string) => {
  const { setPageTitle } = usePageName();

  useEffect(() => {
    setPageTitle(title);
  }, [title, setPageTitle]);
};
